import axios from "axios";
import { BASE_URL } from "./utils";

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
  headers: { 'ngrok-skip-browser-warning': 'true' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
